import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Clip({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M13.4498 9.38L7.91983 14.909C7.26983 15.549 7.26983 16.589 7.91983 17.229H7.90983C8.54983 17.869 9.58983 17.869 10.2298 17.229L18.8498 8.603C20.1298 7.313 20.1298 5.233 18.8498 3.953C18.8398 3.943 18.8398 3.943 18.8398 3.943C17.5498 2.653 15.4698 2.653 14.1898 3.933C14.1798 3.933 14.1798 3.933 14.1798 3.933L5.54983 12.553V12.552C3.61983 14.472 3.61983 17.592 5.53983 19.512C7.45983 21.432 10.5798 21.432 12.4998 19.512C12.4998 19.502 12.4998 19.502 12.4998 19.502L18.7998 13.202" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Clip;